import { render, staticRenderFns } from "./beizhu.vue?vue&type=template&id=126d94ee&scoped=true&"
import script from "./beizhu.vue?vue&type=script&lang=js&"
export * from "./beizhu.vue?vue&type=script&lang=js&"
import style0 from "./beizhu.vue?vue&type=style&index=0&id=126d94ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d94ee",
  null
  
)

export default component.exports